import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getOperationsSelector } from '../selectors'
import { setAddToTimeLine } from '../store/operations.actions'
import { OperationsConstants } from '../store/operations.constants'
import { IOperationsState } from '../store/operations.types'
import { getOperationsAction } from '../utilities/saveOperations.util'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { addOperationsItem } from '../../../timeline/store/timeline.actions'
import { getServiceIdSelector } from '../../../user/selectors'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../../utilities/nemsisCode.util'

export function* saveOperations() {
  let operationsState: IOperationsState = yield select(getOperationsSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  if (!pcrID) {
    // todo: add to audit log
    return
  }

  try {
    operationsState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: operationsState,
      actionField: getOperationsAction,
      filter1Field: null,
      filter2Field: null,
      filter3Field: null,
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    operationsState = handleNemsisCodeError(error, operationsState)
  }

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.operationsStateList && pcrDoc.patient?.operationsStateList.length) {
    const index = pcrDoc.patient?.operationsStateList?.findIndex((operations) => operations.key === operationsState.key)
    if (index !== -1) {
      pcrDoc.patient.operationsStateList[index] = operationsState
    } else {
      pcrDoc.patient?.operationsStateList.push(operationsState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, operationsStateList: [operationsState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addOperationsItem())
  } catch (e) {
    yield put(throwPcrException(`saveOperations() error: ${e}`))
  }
}

export function* saveOperationsSaga() {
  yield takeLatest(
    [
      OperationsConstants.SAVE_OPERATIONS,
      OperationsConstants.SET_DATE,
      OperationsConstants.SET_TIME,
      OperationsConstants.SET_DATE_TIME,
      OperationsConstants.SET_ASSESSED_BY,
      OperationsConstants.SET_RESPONSE,
      OperationsConstants.SET_RESPONSE_PNNV,
      OperationsConstants.SET_PROCEDURE_COMPLICATIONS,
      OperationsConstants.SET_AUTHORIZATION,
      OperationsConstants.SET_ATTEMPTS,
      OperationsConstants.SET_LAST_NAME,
      OperationsConstants.SET_FIRST_NAME,
      OperationsConstants.SET_STRETCHER_CHAIR_MOVING_TO,
      OperationsConstants.SET_JOINT_COMMISSION_TIME_OUT,
      OperationsConstants.SET_RIGHT_PATIENT,
      OperationsConstants.SET_RIGHT_PROCEDURE,
      OperationsConstants.SET_RIGHT_CONSENT,
      OperationsConstants.SET_RIGHT_SITE_SIDE,
      OperationsConstants.SET_RIGHT_POSITION,
      OperationsConstants.SET_COMPLETE,
      OperationsConstants.SET_SAFETY_BRIEF,
      OperationsConstants.SET_HEARING_PRECAUTIONS,
      OperationsConstants.SET_ENVIRONMENTAL_CONTROLS,
      OperationsConstants.SET_SAFETY_RESTRAINTS,
      OperationsConstants.SET_SEIZURE_PRECAUTIONS,
      OperationsConstants.SET_PATIENT_LOADED_COLD,
      OperationsConstants.SET_PATIENT_LOADED_HOT,
      OperationsConstants.SET_PATIENT_OFFLOAD_COLD,
      OperationsConstants.SET_PATIENT_OFFLOAD_HOT,
      OperationsConstants.SET_PATIENT_MONITORING,
      OperationsConstants.SET_PEDIATRIC_STRETCHER_CHAIR,
      OperationsConstants.SET_PEDIATRIC_SAFETY_RESTRAINT_DEVICE,
      OperationsConstants.SET_BABYPOD,
      OperationsConstants.SET_PEDIMATE,
      OperationsConstants.SET_PATIENT_PERSONAL_PROTECTIVE_EQUIPMENT,
      OperationsConstants.SET_ROLE_PERFORMING,
      OperationsConstants.SET_ROLE_PERFORMING_PNNV,
      OperationsConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      OperationsConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      OperationsConstants.SET_JOINT_COMMISSION_TIMEOUT_ARRAY,
      OperationsConstants.SET_PTA,
    ],
    performWithMutexHOG,
    saveOperations
  )
}
